module.exports = __webpack_public_path__ + "Tinebase/js/ace-theme-solarized_dark-FAT.js";